export const types = function () {
  return ["date", "month", "range", "week", "time", "timeRange"];
};



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/Date/tools.js